// TeamLogo.js — a league team's mark: a logo image when one is available,
// else initials on a solid fill. Mirrors iOS's TeamMark (Shared/TeamMark.swift)
// — LeagueTeams.logoUrl (2026-08) is optional and most teams have none, so
// the initials rendering is the permanent fallback, not a transitional one.
// Used by both the Coach tier (CoachTeamsPage/CoachPlayersPage) and the
// League tier (LeagueTeamsPage) — team logo uploads apply to both.

function initialsFor(name) {
  const words = (name || "").trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  return words.slice(0, 2).map((w) => w[0].toUpperCase()).join("");
}

export default function TeamLogo({ name, logoUrl, size = 40 }) {
  const style = {
    width: size,
    height: size,
    minWidth: size,
    borderRadius: "50%",
    flexShrink: 0,
  };

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt=""
        style={{ ...style, objectFit: "cover", border: "1px solid var(--border-subtle)" }}
      />
    );
  }

  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--bg-card-hover)",
        border: "1px solid var(--border-subtle)",
        color: "var(--text-secondary)",
        fontSize: Math.round(size * 0.38),
        fontWeight: 700,
      }}
    >
      {initialsFor(name)}
    </div>
  );
}
